import { AddUserLanguage } from '../../../i18n'
import CLanguageHandler from '../../NonReact/Languages/LanguageHandler'
import { INVALID_VALUE } from '../Common/API/ItemsGetters'
import { SelectOptions } from '../Common/Components/Selects'
import { SelectOption } from '../Common/Components/Selects/Types'
import { StateSetter } from '../Common/Types/Types'
import { SERVER_UNKNOWN_VALUE } from './Constants'

const language: CLanguageHandler = CLanguageHandler.getInstance()

export const handleUnknownForAvailables = <T extends number | string, U extends number[] | number | string>(
    availables: SelectOptions<T>,
    setter: StateSetter<SelectOptions<T>> | StateSetter<Definable<SelectOptions<T>>>,
    value: U
): void => {
    language.loadBundle(AddUserLanguage.NAME)

    let adjustedValue: T

    if (Array.isArray(value)) {
        adjustedValue = (value.find((v: number): boolean => v === INVALID_VALUE) ?? value[0]) as T
    } else {
        adjustedValue = value as unknown as T
    }

    setter(
        adjustedValue !== INVALID_VALUE && adjustedValue !== SERVER_UNKNOWN_VALUE
            ? availables
            : [
                  {
                      label: language.get(AddUserLanguage.UnknownOrDeleted),
                      value: adjustedValue
                  },
                  ...availables
              ]
    )
}

export const removeUnknownOption = <T extends number | string, U extends number[] | number | string>(
    setter: StateSetter<SelectOptions<T>>,
    value: U
): void => {
    if (
        value === SERVER_UNKNOWN_VALUE ||
        value === INVALID_VALUE ||
        (Array.isArray(value) && value.includes(INVALID_VALUE))
    ) {
        return
    }

    setter((availables: SelectOptions<T>) =>
        availables.filter(
            (available: SelectOption<T>): boolean =>
                available.value !== SERVER_UNKNOWN_VALUE && available.value !== INVALID_VALUE
        )
    )
}
